import React from "react";
import { RadialBarChart } from "./dashboard";
export default function InterviewCard(props) {
  return (
    <>
      <div className="p-2 md:p-7 md:w-[100%] lg:w-[100%] flex justify-center  ">
        <div className="flex justify-between border-2 border-primary rounded-2xl p-6 lg:p-20 lg:px-24 lg:border-lg lg:text-xl">
          <div className=" md:p-6 lg:p-6 md:px-16 lg:px-16">
            <h1 className="md:p-3 lg:p-3 font-bold text-sm md:text-lg lg:text-lg whitespace-nowrap">
              Total Interviews completed - <span>{props.completed}</span>
            </h1>
            <div className="flex flex-col">
              <span className=" pt-4 md:p-3 lg:p-3 ">
                Technical Skills <span className="pl-[10px]"></span> -{" "}
                <span className="text-primary">{props.tech ?? 0}</span>
              </span>
              <span className="pt-4 md:p-3 lg:p-3">
                Communication -{" "}
                <span className="text-primary">{props.communication ?? 0}</span>
              </span>
            </div>
          </div>
          <div className="md:px-12 lg:px-12 ">
            <RadialBarChart score={props.score ?? 0} label={"Overall Score"} />
          </div>
        </div>
      </div>
    </>
  );
}
